<div class="edit_question_modal" [formGroup]="form">
  <div class="modal_title">
    <div>
      <h2>{{ isEditMode() ? 'Edit MCQ Set' : 'Create New MCQ Set' }}</h2>
      <p>{{ isEditMode() ? 'Update the details below' : 'Fill in the details below to create a new test for your students' }}</p>
    </div>
    <p-button class="close_modal" icon="pi pi-times" (click)="closeDialog()" role="button" [tabIndex]="0"></p-button>
  </div>

  @if (isLoading()) {
    <div class="loading-overlay">Loading...</div>
  }

  <div class="form_grid v2 gap_p">
    @for (fc of fieldConfigs(); track fc.key) {
      <div class="{{ fc.colClass }}">
        <label [for]="fc.key">{{ fc.label }}</label>

        @switch (fc.type) {
          @case ('text') {
            <input pInputText appSpaceAtFirst class="form_field" [id]="fc.key" [placeholder]="fc.placeholder" [formControlName]="fc.key" />
          }
          @case ('textarea') {
            <textarea pTextarea appSpaceAtFirst class="form_field" rows="3" [placeholder]="fc.placeholder" [formControlName]="fc.key"></textarea>
          }
         @case ('number') {
  <input 
    pInputText 
    techy-numbersOnly 
    appSpaceAtFirst 
    class="form_field" 
    [class.calculated-field]="fc.key === 'timePerQuestionSec'"
    type="number" 
    [id]="fc.key" 
    [placeholder]="fc.placeholder" 
    [formControlName]="fc.key" 
  />
}

          @case ('select-multi') {
            <p-multiselect
              class="w_100"
              [options]="subjects()"
              optionLabel="name"
              optionValue="_id"
              [formControlName]="fc.key"
              placeholder="Select subjects"
              [maxSelectedLabels]="3"
              [showClear]="true"
              [filter]="true"
            ></p-multiselect>
          }
        }

        @if (isInvalid(fc.key)) {
          <small class="error_msg"> {{ getError(fc.key) }} </small>
        }
      </div>
    }
  </div>

 <div class="form_grid v2 gap_p mt_20">
    <div class="w_100">
      <label for="rules">Guidelines / Rules (Optional)</label>
      <p-editor 
        formControlName="rules" 
        appSpaceAtFirst
        [style]="{'height':'320px'}"
              (onBlur)="form.controls.rules.markAsTouched()">
      </p-editor>



    </div>


  </div>


  <div class="form_grid v2 gap_p mt_20">
    <div class="w_100">
      <div class="sample_questions_header">
        <label for="sample">Sample Questions (Optional - Max 2)</label>
        @if (canAddMoreSamples()) {
          <p-button 
            icon="pi pi-plus" 
            label="Add Sample" 
            variant="outlined"
            size="small"
            (click)="addSampleQuestion()" 
            type="button">
          </p-button>
        }
      </div>

      <div formArrayName="sampleQuestions">
        @for (sqGroup of sampleQuestions.controls; track $index) {
          <div [formGroupName]="$index" class="sample_question_item">
            <div class="sample_question_row">
              <div class="w_100">
                <label for="question">Question {{ $index + 1 }}</label>
                <textarea 
                  pTextarea 
                  class="form_field" 
                  rows="2" 
                  appSpaceAtFirst
                  placeholder="Enter sample question" 
                  formControlName="question">
                </textarea>
              </div>
              <div class="w_100">
                <label for="answer">Answer {{ $index + 1 }}</label>
                <textarea 
                  pTextarea 
                  class="form_field" 
                  rows="2" 
                  appSpaceAtFirst
                  placeholder="Enter sample answer" 
                  formControlName="answer">
                </textarea>
              </div>
              <p-button 
                icon="pi pi-trash" 
                variant="text" 
                severity="danger"
                (click)="removeSampleQuestion($index)" 
                type="button">
              </p-button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="btn_flex mt_30">
    <p-button variant="outlined" label="Cancel" (click)="closeDialog()" role="button" [tabIndex]="1"></p-button>
    <p-button 
      [label]="isEditMode() ? 'Update MCQ Set' : 'Create MCQ Set'" 
      (click)="onSubmit()" 
      role="button" 
      [tabIndex]="2"
      [disabled]="isLoading()">
    </p-button>
  </div>
</div>
